import React, { createContext, useContext, useState } from 'react';

interface PageIdContextType {
	activePageId: string | null;
	setActivePageId: (id: string | null) => void;
}

const PageIdContext = createContext<PageIdContextType | undefined>(undefined);

export const PageIdProvider = ({ children }: { children: React.ReactNode }) => {
	const [activePageId, setActivePageId] = useState<string | null>(null);

	return (
		<PageIdContext.Provider value={{ activePageId, setActivePageId }}>
			{children}
		</PageIdContext.Provider>
	);
};

export const usePageId = () => {
	const ctx = useContext(PageIdContext);
	if (!ctx) throw new Error('usePageId must be used within PageIdProvider');
	return ctx;
};
